// TODO : remove test mappings after changes in the fields meta
import { isEmpty } from 'lodash';
import { ProgressStatus } from 'api/project';
import { Color } from 'components/colors';

export interface StatusTypes {
  [key: string]: ProgressStatus;
}

export const status: StatusTypes = {
  0: {
    color: 'cyan' as Color,
    group: 1,
    label: 'Active',
    key: 'active',
    value: 1,
  },
  1: {
    color: 'cyan' as Color,
    group: 1,
    label: 'To do',
    key: 'todo',
    value: 1,
  },
  2: {
    color: 'green' as Color,
    group: 2,
    label: 'In Progress',
    key: 'inProgress',
    value: 2,
  },
  3: {
    color: 'green' as Color,
    group: 3,
    label: 'Completed',
    key: 'completed',
    value: 3,
  },
  4: {
    color: 'cool-gray' as Color,
    group: 4,
    label: 'Blocked',
    key: 'blocked',
    value: 4,
  },
  5: {
    color: 'cool-gray' as Color,
    group: 5,
    label: 'Proposed',
    key: 'proposed',
    value: 5,
  },
  6: {
    color: 'cool-gray' as Color,
    group: 6,
    label: 'In Planning',
    key: 'inPlanning',
    value: 6,
  },
  7: {
    color: 'cool-gray' as Color,
    group: 7,
    label: 'To be Staffed',
    key: 'toBeStaffed',
    value: 7,
  },
  8: {
    color: 'cool-gray' as Color,
    group: 8,
    label: 'Cancelled',
    key: 'cancelled',
    value: 8,
  },
};

export const getStatusData = (
  type: StatusTypes,
  text: string | undefined,
): ProgressStatus | undefined => {
  if (!isEmpty(text) && !isEmpty(type)) {
    return Object.values(type).find(
      (each) => each?.label?.toLowerCase() === text?.toLowerCase(),
    );
  }

  return undefined;
};
